import { Grid, GridItem, Text, useToast } from '@chakra-ui/react';
import { ELEMENT_CREATED } from 'constants/mixpanel';
import { Mixpanel } from 'libs/third-party/Mixpanel/mixpanel';
import { ElementTypes } from 'modules/Editor/components/WidgetMenu/SideMenu/ElementsMenu/Elements/Elements.types';
import { QRCodeGenerator } from 'modules/Editor/components/WidgetMenu/SideMenu/QRCodeMenu/QRCodeGenerator';
import { addNewWidget, getInitialWidgetPosition, useAppDispatch } from 'modules/Editor/store';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { generateDefaultData as generateQRDefaultData } from 'widgets/QRCodeWidget/QRCodeWidget.helpers';

export const QRCodeMenuPack = (): ReactElement => {
  const dispatch = useAppDispatch();
  const toast = useToast();
  const { t } = useTranslation('editor_widget_menu', { useSuspense: false, keyPrefix: 'sideMenu.qrCodeMenu' });
  const addQRCodeWidget = (url: string) => {
    const { top, left } = getInitialWidgetPosition();
    const widgetData = generateQRDefaultData(url, top, left);
    dispatch(addNewWidget(widgetData));

    Mixpanel.track(ELEMENT_CREATED.eventName, {
      from: ELEMENT_CREATED.from.LeftPanel,
      element_id: 'qr_code',
      element_type: ElementTypes.QRCode,
    });
    toast({ title: t('qrSuccess') });
  };

  return (
    <>
      <Grid templateColumns={'1fr'} columnGap={4} rowGap={4} paddingLeft={2} paddingRight={6}>
        <Text as='p' mb={4} fontSize='sm' fontWeight='normal'>
          {t('description')}
        </Text>
        <GridItem>
          <QRCodeGenerator onChange={addQRCodeWidget} />
        </GridItem>
      </Grid>
    </>
  );
};

QRCodeMenuPack.displayName = 'QRCodeMenuPack';
